import React from "react";
import Result from "./components/Result/Result";
import SearchResultListItem from "./models/item.interface";
import styles from "./Search.module.scss";
import useDebounce from "./hooks/useDebounce";

import { FunctionComponent, useState, useEffect } from "react";
import fetchSearchByRoute from "./helpers/fetchSearchByRoute";
import IconViewer from "components/IconViewer/IconViewer";
import useTranslation from "components/Dictionary/hooks/useTranslation";
import { useSelector } from "react-redux";

const Search: FunctionComponent<any> = (props) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [items, setItems] = useState<any[] | undefined>([]);
    const [loading, setLoading] = useState(false);

    const page = useSelector(state => state.page.content);
    const translations = useTranslation("HEADER.SEARCH.PLACEHOLDER");

    const fetchSearchResults = async (searchQuery: string) => {
        if (!searchQuery || searchQuery.trim() === "") return;

        if (searchQuery.length > 0) {
            const response: SearchResultListItem = await fetchSearchByRoute(`${page?._homeNodeUrl}`, searchQuery);
            return response.items;
        }
    };

    useEffect(() => {
        searchQuery.length > 0 ? setLoading(true) : setLoading(false);
        if (searchQuery.length === 0) setItems([]);
    }, [searchQuery]);

    const fetchResults = async () => {
        setLoading(false);
        const fetchedItems = await fetchSearchResults(searchQuery);
        setItems(fetchedItems);
    };

    useDebounce(searchQuery, 500, fetchResults);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setSearchQuery(e.target.value);
    };

    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>
                <label className={styles.inner}>
                    <input type="text" className={styles.input} value={searchQuery} placeholder={translations["HEADER.SEARCH.PLACEHOLDER"]} onChange={handleInputChange} />
                    <IconViewer className={styles.icon} name="search" />
                </label>

                <div className={styles.results}>
                    {loading ? (
                        <div>
                            {/* TODO: Swap the loader to a more discrete spinner */}
                            <div className={styles.loader}>Loading...</div>
                        </div>
                    ) : null}

                    {!loading && items && items.map((item: any) => {
                        return (
                            <Result key={item.content.name} wrapperElementRef={props.wrapperElementRef} {...item} />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Search;